import React, { useContext, useMemo } from "react";
import FlowContext from "../../../../contexts/flowContext";
import SidebarContext from "../../../../contexts/sidebar";
import styles from "./edgeList.module.css";
import Node from "./Node";

const EdgeList = () => {
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [, sidebarDispatcher] = useContext(SidebarContext);

  const edgeList = useMemo(() => {
    return flowState.edges.sort((a, b) =>
      a.label.normalize().localeCompare(b.label.normalize())
    );
  }, [flowState.edges]);

  const handleEdgeClick = function (edge) {
    flowDispatcher({
      type: "unselect-all-nodes",
    });
    flowDispatcher({
      type: "set-selected-edge",
      id: edge.id,
    });
    sidebarDispatcher({
      type: "set-manager",
      manager: "edge",
    });

    const linkedNodes = flowState.nodes.filter(
      (node) => node.id === edge.source || node.id === edge.target
    );

    flowState.rfInstance.fitBounds(
      {
        x: (linkedNodes[0].position.x + linkedNodes[1].position.x) / 2,
        y: (linkedNodes[0].position.y + linkedNodes[1].position.y) / 2,
        width: 100,
        height: 100,
      },
      { duration: 1000, zoomLevel: 1 }
    );
  };

  return (
    <div className={styles.edge_list_container}>
      {edgeList.map((edge, index) => (
        <div
          className={styles.edge_container}
          key={index}
          onClick={() => handleEdgeClick(edge)}
        >
          <div>
            <Node id={edge.source} />
          </div>
          <div className={styles.edge}>
            <span className={styles.edge_label}>{edge.label}</span>
            <div className={styles.edge_arrow}>
              <hr />
            </div>
          </div>
          <div>
            <Node id={edge.target} />
          </div>
        </div>
      ))}
      {!edgeList.length && (
        <div className={styles.no_edge_message}>
          <p>Commencez par lier des noeuds</p>
        </div>
      )}
    </div>
  );
};

export default EdgeList;
